import React from 'react';
import landingPic from '../../img/genlinkApp.jpg'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import * as routes from '../../constants/routes';
import { Link } from 'react-router-dom'

const styles = {
  content: {
    padding: '40px',
    backgroundColor: 'rgba(248,248,255,0.5)',
   
    
  },
  bgWrapper: {
    marginTop: '-24px',
    marginLeft: '-21px',
    marginRight: '-21px',
    minHeight: '400px',
    backgroundImage: `url(${landingPic})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  }
}
const LandingPage = (props) => {
  //const isLoggedIn = !_.isEmpty(props.loggedIn)
  const user = props.loggedIn
  return (
    <div style={styles.bgWrapper}>
        <div style={styles.content}>
          {props.loggedIn!==null
            ? <UserLoggedIn name={user.name} vorname={user.vorname || ''} />
            : <UserLoggedOut />

          }
        </div>

    </div>
  )
}


const UserLoggedIn = ({name, vorname}) => {

  return  (
    <div>
      <h1>Herzlich Willkommen</h1>
      <h2>{vorname} {name}</h2>
      <h3>Sie sind angemeldet und können loslegen.</h3>
    </div>)
}

const UserLoggedOut = () => {
  return ( 
    <div>
      <h1>Herzlich Willkommen</h1>
      <h3>Sie müssen sich anmelden um die App benutzen zu können!</h3>
      <Link className='navLink' to={routes.SIGN_IN}>
        <Button 
          color="primary"
          variant='contained'
          size='large'
        >
          Anmelden
        </Button>
      </Link>
      <h3>Wir wünschen Ihnen viel Freude am vermitteln</h3>
    </div>
  )
}

const mapStateToProps = (state) => ({
  loggedIn: state.userState.profile
})
export default connect(mapStateToProps)(LandingPage);


// WEBPACK FOOTER //
// ./src/Components/App/Landing.js